export const FREE_FEATURES = [
  "subscriptionPlans.free.features.videoCreations",
  "subscriptionPlans.free.features.tokens",
  "subscriptionPlans.free.features.editing",
  "subscriptionPlans.free.features.analytics",
  "subscriptionPlans.free.features.watermark",
];

export const PRO_FEATURES = [
  "subscriptionPlans.pro.features.videoCreations",
  "subscriptionPlans.pro.features.tokens",
  "subscriptionPlans.pro.features.editing",
  "subscriptionPlans.pro.features.avatarLibrary",
  "subscriptionPlans.pro.features.analytics",
  "subscriptionPlans.pro.features.noBranding",
];

export const TEAM_FEATURES = [
  "subscriptionPlans.team.features.experiences",
  "subscriptionPlans.team.features.tokens",
  "subscriptionPlans.team.features.sharedWorkspace",
  "subscriptionPlans.team.features.templateLibrary",
  "subscriptionPlans.team.features.customExperience",
  "subscriptionPlans.team.features.adminControls",
];

export const BUSINESS_FEATURES = [
  "subscriptionPlans.business.features.workspaces",
  "subscriptionPlans.business.features.avatar",
  "subscriptionPlans.business.features.api",
  "subscriptionPlans.business.features.sso",
  "subscriptionPlans.business.features.csm",
  "subscriptionPlans.business.features.workflows",
];
